import api from "../api-backend";

class HomeIAService {

    getLastWeeklySummary = async (locale = 'es') => {
        const response = await api.get(`/home-ia/last?locale=${locale}`)
        return response.data
    }

}

export default new HomeIAService()











